import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#4893F4",
      d: "M18 20.5h-1v-.25c0-1.1-.9-2-2-2h-2.25v-2.29c-.25.03-.5.04-.75.04s-.5-.01-.75-.04v2.29H9c-1.1 0-2 .9-2 2v.25H6c-.41 0-.75.34-.75.75s.34.75.75.75h12c.41 0 .75-.34.75-.75s-.34-.75-.75-.75M5.52 11.64c-.66-.25-1.24-.66-1.7-1.12-.93-1.03-1.54-2.26-1.54-3.7s1.13-2.57 2.57-2.57h.56C5.15 4.78 5 5.37 5 6v3c0 .94.18 1.83.52 2.64M21.72 6.82c0 1.44-.61 2.67-1.54 3.7-.46.46-1.04.87-1.7 1.12.34-.81.52-1.7.52-2.64V6c0-.63-.15-1.22-.41-1.75h.56c1.44 0 2.57 1.13 2.57 2.57",
      opacity: ".4"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#4893F4",
      d: "M15 2H9C6.79 2 5 3.79 5 6v3c0 3.87 3.13 7 7 7s7-3.13 7-7V6c0-2.21-1.79-4-4-4m-.16 6.45-.62.76c-.1.11-.17.33-.16.48l.06.98c.04.6-.39.91-.95.69l-.91-.36a.9.9 0 0 0-.52 0l-.91.36c-.56.22-.99-.09-.95-.69l.06-.98a.75.75 0 0 0-.16-.48l-.62-.76c-.39-.46-.22-.97.36-1.12l.95-.24c.15-.04.33-.18.41-.31l.53-.82c.33-.51.85-.51 1.18 0l.53.82c.08.13.26.27.41.31l.95.24c.58.15.75.66.36 1.12"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#4893F4",
      d: "m14.84 8.45-.62.76c-.1.11-.17.33-.16.48l.06.98c.04.6-.39.91-.95.69l-.91-.36a.9.9 0 0 0-.52 0l-.91.36c-.56.22-.99-.09-.95-.69l.06-.98a.75.75 0 0 0-.16-.48l-.62-.76c-.39-.46-.22-.97.36-1.12l.95-.24c.15-.04.33-.18.41-.31l.53-.82c.33-.51.85-.51 1.18 0l.53.82c.08.13.26.27.41.31l.95.24c.58.15.75.66.36 1.12",
      opacity: ".4"
    }, null, -1)
  ]))]))
}
export default { render: render }